import React from 'react';
import { Route } from "react-router-dom";

import PublicLayout from '../services/PublicLayout';
  
const PublicRoute = ({ path, component: Component }) => {

  return (
    <PublicLayout>
      <Route path={path} component={Component} />
    </PublicLayout>
  );
}

export default PublicRoute;
